import { updateBeamUrl } from '@utils/updateBeamUrl/updateBeamUrl';

export interface IPicture {
  id: string;
  name: string;
  type: 'uri' | 'file';
  uri?: string;
  file?: {
    uri: string;
    path: string;
  };
  createdAt: Date;
  updatedAt: Date;
}

export interface IPictureApiModel {
  id: string;
  name: string;
  type: 'uri' | 'file';
  uri?: string;
  file?: {
    uri: string;
    path: string;
  };
  createdAt: string;
  updatedAt: string;
}

export default class Picture implements IPicture {
  public readonly id: string;

  public readonly name: string;

  public readonly type: 'uri' | 'file';

  public readonly uri?: string;

  public readonly file?: { uri: string; path: string };

  public readonly createdAt: Date;

  public readonly updatedAt: Date;

  constructor(
    id: string,
    name: string,
    type: 'uri' | 'file',
    createdAt: Date,
    updatedAt: Date,
    uri?: string,
    file?: { uri: string; path: string },
  ) {
    this.id = id;
    this.name = name;
    this.type = type;
    this.uri = uri;
    this.file = file;
    this.createdAt = createdAt;
    this.updatedAt = updatedAt;
  }

  static fromApiModel(apiModel: IPictureApiModel) {
    const { id, name, type } = apiModel;
    const uri = apiModel.uri ? updateBeamUrl(apiModel.uri) : undefined;
    const file = apiModel.file
      ? {
          uri: updateBeamUrl(apiModel.file.uri),
          path: updateBeamUrl(apiModel.file.path),
        }
      : undefined;
    const createdAt = new Date(Date.parse(apiModel.createdAt));
    const updatedAt = new Date(Date.parse(apiModel.updatedAt));

    return new Picture(id, name, type, createdAt, updatedAt, uri, file);
  }

  static arrayFromApiModel(arrayApiModel: IPictureApiModel[]) {
    const array = arrayApiModel.map(apiModel => Picture.fromApiModel(apiModel));

    return array;
  }
}
